var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"copyright"},[_c('small',[_vm._v(" "+_vm._s(_vm.currentYear)+"© "),(_vm.withLink)?_c('a',{attrs:{"href":_vm.creditsUrl,"target":"_blank"}},[_c('b',[_vm._v(_vm._s(_vm.creditsText))])]):_c('b',[_vm._v(_vm._s(_vm.creditsText))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }